<template>
  <div>
    <el-row>
      <el-col :span="4" style="margin-top: 20px; ">
        <el-tree :data="data" default-expand-all :props="defaultProps" @node-click="handleNodeClick"></el-tree>
      </el-col>
      <el-col :span="20" style="margin-top: 20px; ">
        <el-input
            class="input-new-tag"
            v-if="inputVisible"
            v-model="inputValue"
            ref="saveTagInput"
            size="small"
            @keyup.enter.native="handleInputConfirm"
            @blur="handleInputConfirm"
        >
        </el-input>
        <el-button v-else class="button-new-tag" size="small" @click="showInput">+ 添加新疾病</el-button>
        <el-tag
            :key="tag.name"
            :id="tag.entity_id"
            v-for="tag in dynamicTags"
            closable
            effect="plain"
            :disable-transitions="false"
            @click="handleOpenSymptomClick(tag)"
            @close="handleClose(tag)">
          {{ tag.name }}
        </el-tag>


        <el-dialog :title="disease_name" :visible.sync="dialogFormVisible">
          <el-row>
            <h5>已有症状</h5>
            <el-col :span="24" style="margin-top: 20px; ">
              <div v-bind:key="key" v-for="(key, val) in  symptomCatAndSymptomTags">
                {{ val }}:{{ key }}
              </div>
            </el-col>
          </el-row>
          <el-row>

            <el-col :span="12" style="margin-top: 20px; ">
              <h5>症状分类</h5>
              <el-tag
                  :key="tag.name"
                  :id="tag.name"
                  :type="tag.type"
                  v-for="tag in symptomCatTags"
                  effect="plain"
                  :disable-transitions="false"
                  @click="showDiseaseSymptoms(tag)"
                  @close="handleClose(tag)">
                {{ tag.name }}
              </el-tag>
            </el-col>

            <el-col :span="12" style="margin-top: 20px; ">
              <h5>症状</h5>
              <el-input
                  class="input-new-tag"
                  v-if="inputVisible2"
                  v-model="inputValue2"
                  ref="saveTagInput2"
                  size="small"
                  @keyup.enter.native="handleInputConfirm2"
                  @blur="handleInputConfirm2"
              >
              </el-input>
              <el-button v-else class="button-new-tag" size="small" @click="showInput2">+ 添加新症状</el-button>

              <el-tag
                  :key="tag.name"
                  :id="tag.name"
                  v-for="tag in symptomTags"
                  closable
                  effect="plain"
                  :type="tag.type"
                  :disable-transitions="false"
                  @close="handleClose2(tag)">
                {{ tag.sym_name }}
              </el-tag>

            </el-col>
          </el-row>
        </el-dialog>


      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "DiseaseAnnoView",
  data() {
    return {
      disease_category: "",
      sysmptom_category: "",
      dynamicTags: [],
      symptomCatTags: [],
      disease_id: "",
      disease_name: "",
      symptomCatAndSymptomTags: [],
      symptomTags: [],
      inputVisible: false,
      inputVisible2: false,
      inputValue: '',
      inputValue2: '',
      dialogFormVisible: false,
      dialogTableVisible: false,
      formLabelWidth: '120px',
      form: {
        name: '',
        region: '',
        date1: '',
        date2: '',
        delivery: false,
        type: [],
        resource: '',
        desc: ''
      },

      data: [{
        label: '疾病',
        children: [{
          label: '西医疾病',
          children: [{
            label: '代谢疾病'
          }, {
            label: '内分泌系统'
          }, {
            label: '口腔疾病'
          }, {
            label: '呼吸系统'
          }, {
            label: '循环系统'
          }, {
            label: '泌尿系统'
          }, {
            label: '消化系统'
          }, {
            label: '生化因子'
          }, {
            label: '生殖系统'
          }, {
            label: '皮肤疾病'
          }, {
            label: '眼部疾病'
          }, {
            label: '神经系统'
          }, {
            label: '精神心理'
          }, {
            label: '耳鼻咽喉'
          }, {
            label: '血液疾病'
          }, {
            label: '运动系统'
          }, {
            label: '风湿免疫'
          }]
        }, {
          label: '冲/任'
        }, {
          label: '心/小肠'
        }, {
          label: '气血津液'
        }, {
          label: '肝/胆'
        }, {
          label: '肢体经络'
        }, {
          label: '肺/大肠'
        }, {
          label: '肾/膀胱'
        }, {
          label: '脾/胃'
        }]
      }],
      defaultProps: {
        children: 'children',
        label: 'label'
      }
    };
  },
  mounted() {
    this.$http.get(process.env.VUE_APP_API_HOST+"/query_disease_by_category?cat=疾病" ).then((res) => {
      this.dynamicTags = res.data.data
    })
  },
  methods: {
    addNewDisease(disease_cat, disease_name) {
      this.$http.post(process.env.VUE_APP_API_HOST+"/add_disease", {
        "disease_cat": disease_cat,
        "disease_name": disease_name
      }, {"content-type": "application/json"}).then((res) => {
        console.log(res)
      })
    },
    addNewSymptom(jb_id, symptom_cat, symptom_name) {
      this.$http.post(process.env.VUE_APP_API_HOST+"/add_symptom", {
        "jb_id": jb_id,
        "symptom_cat": symptom_cat,
        "symptom_name": symptom_name
      }, {"content-type": "application/json"}).then((res) => {
        console.log(res)
      })
    },

    deleteSymptom(jb_entity_id, sym_cat_name, sym_name) {
      this.$http.post(process.env.VUE_APP_API_HOST+"/del_symptom", {
        "jb_entity_id": jb_entity_id,
        "sym_cat_name": sym_cat_name,
        "sym_name": sym_name
      }, {"content-type": "application/json"}).then((res) => {
        console.log(res)
      })
    },
    deleteDisease(disease_cat, disease_name) {
      this.$http.post(process.env.VUE_APP_API_HOST+"/del_disease", {
        "disease_cat": disease_cat,
        "disease_name": disease_name.entity_id
      }, {"content-type": "application/json"}).then((res) => {
        console.log(res)
      })
    },
    handleNodeClick(data) {
      // console.log(data)
      this.disease_category = data
      this.$http.get(process.env.VUE_APP_API_HOST+"/query_disease_by_category?cat=" + data['label']).then((res) => {
        this.dynamicTags = res.data.data
      })
    },

    handleOpenSymptomClick(data) {
      this.disease_id = data['entity_id']
      this.disease_name= data['name']

      this.$http.get(process.env.VUE_APP_API_HOST+"/query_symtomp_by_disease_id?jb_id=" + data['entity_id']).then((res) => {
        this.symptomCatTags = res.data.data
        this.symptomCatAndSymptomTags = res.data.symptom_data
        this.dialogFormVisible = true
      })
    },

    showDiseaseSymptoms(data) {
      console.log(data)
      this.sysmptom_category = data
      this.$http.get(process.env.VUE_APP_API_HOST+"/query_sympotom_info?jb_id=" + data['jb_id'] + "&sym_cat_name=" + data['sym_cat_name']).then((res) => {
        this.symptomTags = res.data.data
        this.dialogFormVisible = true
      })
    },

    handleClose(tag) {
      console.log(tag)
      if (confirm('您确定删除该疾病吗?')) {
        this.deleteDisease(this.disease_category.label, tag)
        this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
      }

    },
    handleClose2(tag) {
      if (confirm('您确定删除该症状吗?')) {
        this.deleteSymptom(this.disease_id, this.sysmptom_category.sym_cat_name, tag.sym_name)
        this.symptomTags.splice(this.symptomTags.indexOf(tag), 1);
      }

    },

    showInput() {
      this.inputVisible = true;
      this.$nextTick(_ => {
        console.log(_)
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },
    showInput2() {
      this.inputVisible2 = true;
      this.$nextTick(_ => {
        console.log(_)
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },

    handleInputConfirm() {
      let inputValue = this.inputValue;
      if (inputValue) {
        console.log(inputValue)
        this.addNewDisease(this.disease_category.label, inputValue)
        this.dynamicTags.unshift({"name": inputValue});
      }
      this.inputVisible = false;
      this.inputValue = '';
    },
    handleInputConfirm2() {
      let inputValue = this.inputValue2;
      if (inputValue) {
        this.addNewSymptom(this.disease_id, this.sysmptom_category.sym_cat_name, inputValue)
        this.symptomTags.unshift({"sym_name": inputValue});
      }
      this.inputVisible2 = false;
      this.inputValue2 = '';
    },


  }
}
</script>

<style scoped>
.el-tag + .el-tag {

  margin-left: 10px;
  margin-top: 10px;
  cursor: pointer;
}

.button-new-tag {
  margin-right: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
  cursor: pointer;
}

.input-new-tag {
  width: 90px;
  margin-right: 10px;
  vertical-align: bottom;
  cursor: pointer;
}
</style>
